module.exports = __webpack_public_path__ + "static/img/ls8.79808dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls8.png
// module id = KQlf
// module chunks = 12